import {
  dashboard,
  coursesIcon,
  products,
  reports,
  questionPool,
  settings,
  users,
  shield,
  subscriptions,
  website,
  documentIcon,
  externalLink,
  manage,
  marketing,
  mysubscriptions,
  apprenticeIcon,
  archiveIcon,
  laptopIcon,
  calendarIcon,
  calendarsIcon,
  userIcon,
  bundleBoxIcon,
  homeIcon,
} from "../constants/icons";

export const productsChildren = [
  {
    text: "Courses",
    type: "item",
    link: "#top",
    isReact: false,
  },
  {
    text: "Bundles",
    type: "item",
    link: "#top",
    isReact: false,
  },
  {
    text: "Live Classes",
    type: "item",
    link: "#top",
    isReact: false,
  },
  {
    text: "Online Test",
    type: "item",
    link: "#top",
    isReact: false,
  },
  {
    text: "Training Management System",
    type: "item",
    link: "#top",
    isReact: false,
  },
  {
    type: "divider",
  },
  {
    text: "More Options",
    type: "item",
    link: "#top",
    isReact: false,
    children: [
      {
        text: "Discussion",
        type: "item",
        link: "#top",
        isReact: false,
      },
      {
        text: "Announcement",
        type: "item",
        link: "#top",
        isReact: false,
      },
      {
        text: "Reviews",
        type: "item",
        link: "#top",
        isReact: false,
      },
      {
        text: "Leads",
        type: "item",
        link: "#top",
        isReact: false,
      },
      {
        text: "SEO Settings",
        type: "item",
        link: "#top",
        isReact: false,
      },
    ],
  },
];

export const reportsChildren = [
  {
    text: "Reports Dashboard sdfdf",
    type: "item",
    link: "/dashboard/reports",
    isReact: true,
  },
  {
    text: "Upcoming Events Registrations",
    type: "item",
    link: "/dashboard/reports/upcoming-event-registrations",
    isReact: true,
  },
  {
    text: "Cancelled Registrations",
    type: "item",
    link: "#top",
    isReact: false,
  },
  {
    text: "Upcoming Events Waiting List Registrations",
    type: "item",
    link: "#top",
    isReact: false,
  },
  {
    text: "Transfered Registrants",
    type: "item",
    link: "#top",
    isReact: false,
  },
  {
    text: "Upcoming Events Waiting List Registrations",
    type: "item",
    link: "#top",
    isReact: false,
  },
  {
    text: "Attendance report",
    type: "item",
    link: "#top",
    isReact: false,
  },
  {
    text: "Completed Course / Events Registrants",
    type: "item",
    link: "#top",
    isReact: false,
  },
  {
    text: "Advanced Registration Report",
    type: "item",
    link: "#top",
    isReact: false,
  },
  {
    text: "Registration Count",
    type: "item",
    link: "#top",
    isReact: false,
  },
];

export const sidebarList = [
  {
    "label": "Dashboard",
    "link": "/student-dashboard/",
    "code": "dashboard",
    "type": "item",
    "isReact": true,
    "isDynamic": false,
    "slug": "dashboard",
    "isVisible": true
  },
  {
    "label": "Courses",
    "link": "/student-dashboard/courses",
    "code": "courses",
    "type": "item",
    "isReact": true,
    "isDynamic": false,
    "slug": "mykademy",
    "isVisible": false
  },
  {
    "label": "Bundles",
    "link": "/student-dashboard/bundles",
    "code": "bundles",
    "type": "item",
    "isReact": true,
    "isDynamic": false,
    "slug": "mykademy",
    "isVisible":false
  },
  {
    "label": "Events",
    "link": "/student-dashboard/events",
    "code": "tms",
    "type": "item",
    "isReact": true,
    "isDynamic": false,
    "slug": "tms",
    "isVisible": false
  },
  {
    "label": "Programs",
    "link": "#",
    "code": "eportfolio",
    "type": "item",
    "isReact": false,
    "isDynamic": false,
    "slug": "eportfolio",
    "isVisible": false
  },
  {
    "label": "Documents",
    "link": "/student-dashboard/dms",
    "code": "dms",
    "type": "item",
    "isReact": true,
    "isDynamic": false,
    "slug": "dms",
    "isVisible": false
  },
  {
    "label": "Myconnect",
    "link": "#",
    "code": "myconnect",
    "type": "item",
    "isReact": false,
    "isDynamic": false,
    "slug": "myconnect",
    "isVisible": false
  },
  {
    "label": "Archives",
    "link": "/student-dashboard/archives",
    "code": "archive",
    "type": "item",
    "isReact": true,
    "isDynamic": false,
    "slug": "mykademy",
    "isVisible": false
  },
  {
    "label": "Learner Profile",
    "link": "/student-dashboard/learner-profile",
    "code": "learnerprofile",
    "type": "item",
    "isReact": true,
    "isDynamic": false,
    "slug": "profile",
    "isVisible": true
  },
  {
    "label": "Settings",
    "link": "/student-dashboard/settings",
    "code": "settings",
    "type": "item",
    "isReact": true,
    "isDynamic": false,
    "slug": "settings",
    "isVisible": true
  }
];

export const sidebarIconMap = {
  dashboard: homeIcon,
  courses: coursesIcon,
  bundles: bundleBoxIcon,
  tms: calendarsIcon,
  eportfolio: apprenticeIcon,
  archive: archiveIcon,
  products: products,
  myconnect: laptopIcon,
  reports: reports,
  dms: documentIcon,
  questionpool: questionPool,
  marketing: marketing,
  users: users,
  registrations: subscriptions,
  mysubscriptions: mysubscriptions,
  manage: manage,
  website: website,
  settings: settings,
  security: shield,
  external: externalLink,
  learnerprofile: userIcon
};
